// Constants
import { DOCUMENT_TYPES as documentTypes } from 'src/constants/documentTypes';

export type docTypeItem = {
  key: string;
  value: string;
  label: string;
};

export const useProofDocumentTypes = () => {
  const proofDocumentTypes = documentTypes as docTypeItem[];

  return { proofDocumentTypes };
};
